
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed w-full top-0 z-50 bg-white shadow-md">
      <nav className="mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <a href="/" className="text-3xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              WOTECH
            </a>
          </div>

          {/* Desktop Navigation - Centered */}
          <div className="hidden md:flex items-center space-x-8 absolute left-1/2 transform -translate-x-1/2">
            <a href="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Home</a>
            <a href="/services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Services</a>
            <a href="/products" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Products</a>
            <a href="/about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">About</a>
            <a href="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Contact</a>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <a href="/contact" className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
              Get Started
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 cursor-pointer"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a href="/" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Home</a>
              <a href="/services" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Services</a>
              <a href="/products" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Products</a>
              <a href="/about" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">About</a>
              <a href="/contact" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Contact</a>
              <a href="/contact" className="block mx-3 mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold text-center cursor-pointer">Get Started</a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
